import { Loader } from "@mantine/core";
import { ComponentProps } from "react";
import { FieldValues } from "react-hook-form";

import { useSearchShippingCompany, UseSearchShippingCompanyParams } from "@/features/dashboard/pedidos/_hooks/useSearchShippingCompany";

import { Input } from "../_Input";

type ShippingCompaniesFieldsProps<TFieldValues extends FieldValues> = Omit<ComponentProps<typeof Input.Select<TFieldValues>>, "data" | "leftSection"> &
  Omit<UseSearchShippingCompanyParams, "search">;

export function ShippingCompaniesFields<TFieldValues extends FieldValues>({
  control,
  name,
  onSearchChange,
  getLabel,
  getValue,
  searchValue,
  defaultSearchValue,
  ...props
}: ShippingCompaniesFieldsProps<TFieldValues>) {
  const {
    data: searchShippingCompanyResults,
    actions: { setSearchShippingCompany },
    state: { searchShippingCompany, isFetching: isFetchingShippingCompanies }
  } = useSearchShippingCompany({ search: defaultSearchValue, getLabel, getValue });

  const handleSearchChange = (value: string) => {
    setSearchShippingCompany(value);
    onSearchChange?.(value);
  };

  return (
    <Input.Select
      data={searchShippingCompanyResults.options}
      leftSection={isFetchingShippingCompanies && <Loader size="sm" />}
      searchValue={searchValue || searchShippingCompany}
      onSearchChange={handleSearchChange}
      placeholder="Selecione a transportadora"
      label="Transportadora"
      control={control}
      name={name}
      {...props}
    />
  );
}
